import { Card, List } from 'antd';
import { type RoleSpecsFragment } from '../../../api/fragments/RoleSpecs';
import UserAvatar from '../../../components/UserAvatar';
import RoleUserEmptyList from './RoleUserEmptyList';
import RoleUserListActions from './RoleUserListActions';

export type RoleUserListProps = { role: RoleSpecsFragment };

const RoleUserList = ({ role }: RoleUserListProps) => {
    if (role.users.length === 0) {
        return <RoleUserEmptyList role={role} />;
    }

    return (
        <Card>
            <List>
                {role.users.map(user => (
                    <List.Item key={user.id} extra={<RoleUserListActions role={role} user={user} />}>
                        <List.Item.Meta avatar={<UserAvatar user={user} />} title={user.displayName} />
                    </List.Item>
                ))}
            </List>
        </Card>
    );
};

export default RoleUserList;
